import round from "lodash/round";

const parseAmount = (number: number | undefined | null) => {
    if (typeof number !== "number") {
        return undefined;
    }

    return round(number, 2);
};

export default parseAmount;
